module.exports = __webpack_public_path__ + "static/media/20.827756c9.png";